/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CombineDocuments200ResponseData } from './CombineDocuments200ResponseData';
import {
    CombineDocuments200ResponseDataFromJSON,
    CombineDocuments200ResponseDataFromJSONTyped,
    CombineDocuments200ResponseDataToJSON,
} from './CombineDocuments200ResponseData';

/**
 * 
 * @export
 * @interface CombineDocuments200Response
 */
export interface CombineDocuments200Response {
    /**
     * 
     * @type {CombineDocuments200ResponseData}
     * @memberof CombineDocuments200Response
     */
    data?: CombineDocuments200ResponseData;
}

/**
 * Check if a given object implements the CombineDocuments200Response interface.
 */
export function instanceOfCombineDocuments200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CombineDocuments200ResponseFromJSON(json: any): CombineDocuments200Response {
    return CombineDocuments200ResponseFromJSONTyped(json, false);
}

export function CombineDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineDocuments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CombineDocuments200ResponseDataFromJSON(json['data']),
    };
}

export function CombineDocuments200ResponseToJSON(value?: CombineDocuments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CombineDocuments200ResponseDataToJSON(value.data),
    };
}

